import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { LcardBadge } from 'components/shared/lcard-badge';
import style from './page-loader.module.scss';

export const PageLoader = () => {
 return (
  <Backdrop className={style.root} open>
   <div className={style.content}>
    <LcardBadge />
    <CircularProgress />
   </div>
  </Backdrop>
 );
};
